import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Badge } from 'react-bootstrap';
import { Formsede } from '../Ot/Formsede';
import { actualizarDatos, getDataList, crearDatos, deleteById } from '../../api/common';
import Swal from 'sweetalert2';
import { Alertassw } from '../Alertas/Alertassw';

export const ListaSedesnew = ({ user, refresh, setRefresh }) => {
  const [sedes, setSedes] = useState([]);
  const [dataSede, setDataSede] = useState(null);
  const [modal, setModal] = useState(false);
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    async function fetchSedes() {
      const res = await getDataList('Sedes', { conditions: { cliente: user._id } });
      setSedes(res.data?.data || []);
    }
    if (user._id) fetchSedes();
  }, [refresh, user._id]);

  const handleEditInfo = (event) => {
    setDataSede((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const openEdit = (sede) => {
    setDataSede(sede);
    setIsNew(false);
    setModal(true);
  };

  const handleDelete = async (sede) => {
    if (sede.nameSede === 'Principal') {
      Swal.fire('No permitido', 'La sede Principal no puede eliminarse.', 'warning');
      return;
    }
    const confirm = await Swal.fire({
      title: `¿Eliminar sede "${sede.nameSede}"?`,
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!confirm.isConfirmed) return;
    try {
      await deleteById('Sedes', sede._id);
      setRefresh(!refresh);
      Alertassw('success', 'Sede eliminada correctamente');
    } catch {
      Alertassw('error', 'No se pudo eliminar la sede');
    }
  };

  const openNew = () => {
    // Pre-sugerir campos del cliente
    setDataSede({
      ciudad: user.ciudad || '',
      departamento: user.departamento || '',
      celContacto: user.telefono || '',
      contSede: user.contacto || '',
      dirSede: user.direccion || '',
      emailContacto: user.correo || '',
      nameSede: '',
    });
    setIsNew(true);
    setModal(true);
  };

  const handleGuardar = () => {
    if (isNew) {
      async function crearSede() {
        try {
          await crearDatos('Sedes', { ...dataSede, cliente: user._id });
          setRefresh(!refresh);
          setModal(false);
          Alertassw('success', 'Sede creada correctamente');
        } catch {
          Alertassw('error', 'No se pudo crear la sede');
        }
      }
      crearSede();
    } else {
      async function editarSede() {
        try {
          await actualizarDatos('Sedes', dataSede, dataSede._id);

          // Si es sede Principal → cascade al usuario
          if (dataSede.nameSede === 'Principal') {
            try {
              await actualizarDatos('Usuarios', {
                direccion: dataSede.dirSede,
                ciudad: dataSede.ciudad,
                departamento: dataSede.departamento,
                telefono: dataSede.celContacto,
                contacto: dataSede.contSede,
              }, user._id);
            } catch (_) {
              // No bloquear si falla cascade
            }
          }

          setRefresh(!refresh);
          setModal(false);
          Alertassw('success', 'Sede actualizada correctamente');
        } catch {
          Alertassw('error', 'No se pudo actualizar los datos');
        }
      }
      editarSede();
    }
  };

  return (
    <div>
      <Modal show={modal} onHide={() => setModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isNew ? 'Nueva Sede' : `Editar Sede: ${dataSede?.nameSede}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formsede dataSede={handleEditInfo} Enviar={handleGuardar} dataDefault={dataSede} />
        </Modal.Body>
      </Modal>

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Sedes</h5>
        <Button variant="outline-primary" size="sm" onClick={openNew}>
          + Nueva Sede
        </Button>
      </div>

      <Table striped bordered hover responsive size="sm">
        <thead className="table-light">
          <tr>
            <th>Sede</th>
            <th>Ciudad</th>
            <th>Dirección</th>
            <th>Contacto</th>
            <th>Teléfono</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {sedes.length === 0 ? (
            <tr>
              <td colSpan={7} className="text-center text-muted py-3">
                No hay sedes registradas
              </td>
            </tr>
          ) : (
            sedes.map((sede, index) => (
              <tr key={index}>
                <td>
                  {sede.nameSede}
                  {sede.nameSede === 'Principal' && (
                    <Badge bg="secondary" className="ms-1">Principal</Badge>
                  )}
                </td>
                <td>{sede.ciudad}</td>
                <td>{sede.dirSede}</td>
                <td>{sede.contSede}</td>
                <td>{sede.celContacto}</td>
                <td>{sede.emailContacto}</td>
                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                  <Button variant="outline-secondary" size="sm" className="me-1" onClick={() => openEdit(sede)}>
                    <i className="bi bi-pencil-square" />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDelete(sede)}
                    disabled={sede.nameSede === 'Principal'}
                    title={sede.nameSede === 'Principal' ? 'La sede Principal no puede eliminarse' : 'Eliminar'}
                  >
                    <i className="bi bi-trash" />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
};
